import { loadStripe } from "@stripe/stripe-js";
import { stripePublishableKey } from "utils/stripePublishableKey";
import type {
  CardIssuerClient,
  RenderCardTokenOptions,
} from "utils/cards/cardViewer";

export const stripeCardClient: CardIssuerClient = {
  features: { copyButton: true },
  render: renderStripeCard,
};

async function renderStripeCard({
  cardToken: { issuerId, issuerAccountId, publishableKey, secret },
  selectors,
  style,
  onCopy,
  isCurrent = () => true,
}: RenderCardTokenOptions): Promise<boolean> {
  const stripe = await loadStripe(stripePublishableKey(publishableKey), {
    stripeAccount: issuerAccountId,
  });
  if (!stripe) {
    throw new Error("Could not connect to provider. Please try again later.");
  }

  const { nonce } = await stripe.createEphemeralKeyNonce({
    issuingCard: issuerId,
  });
  if (!isCurrent()) return false;

  const elements = stripe.elements();
  const shown = {
    issuingCard: issuerId,
    nonce,
    ephemeralKeySecret: secret,
    style,
  };
  elements
    .create("issuingCardNumberDisplay", shown)
    .mount(selectors.cardNumber);
  elements.create("issuingCardCvcDisplay", shown).mount(selectors.cvv);
  elements
    .create("issuingCardExpiryDisplay", shown)
    .mount(selectors.expirationDate);

  const cardNumberCopy = elements.create("issuingCardCopyButton", {
    toCopy: "number",
    style,
  });
  cardNumberCopy.mount(selectors.copyCardNumber);
  cardNumberCopy.on("click", () => onCopy("cardNumber"));
  return true;
}
